var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container", attrs: { id: "customers-list" } },
    [
      _c("div", { staticClass: "breadcrumb" }, [_c("navbar")], 1),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("h2", { staticStyle: { "padding-bottom": "20px" } }, [
            _vm._v("客户分群"),
          ]),
          _c("h3", [_vm._v("数据筛选")]),
          _c(
            "el-form",
            {
              staticClass: "search-form",
              attrs: { inline: true, id: "search", size: "small" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "分群" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入分群名称", clearable: "" },
                    model: {
                      value: _vm.search.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.search, "name", $$v)
                      },
                      expression: "search.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "运行状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选运行状态",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.search.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.search, "status", $$v)
                        },
                        expression: "search.status",
                      },
                    },
                    _vm._l(_vm.searchStatusArr, function (item) {
                      return _c("el-option", {
                        key: item.dictId,
                        attrs: { label: item.dictName, value: item.dictId },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "更新方式" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择类型",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.search.updateWay,
                        callback: function ($$v) {
                          _vm.$set(_vm.search, "updateWay", $$v)
                        },
                        expression: "search.updateWay",
                      },
                    },
                    _vm._l(
                      _vm.dictionaries.customer_group_refresh_type,
                      function (item) {
                        return _c("el-option", {
                          key: item.dictId,
                          attrs: { label: item.dictName, value: item.dictId },
                        })
                      }
                    ),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", plain: "" },
                      on: {
                        click: function ($event) {
                          return _vm.fetchData("search")
                        },
                      },
                    },
                    [_vm._v("查询 ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", plain: "" },
                      on: {
                        click: function ($event) {
                          return _vm.fetchData("reset")
                        },
                      },
                    },
                    [_vm._v("重置 ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "btn-list" }, [
          _vm._m(0),
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.addGroup()
                    },
                  },
                },
                [_vm._v("新增 ")]
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "table" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.page.list,
                  "header-cell-style": {
                    background: "#f8f8f8",
                    color: "#363636",
                  },
                },
              },
              [
                _c("el-table-column", {
                  attrs: { label: "分群", prop: "name" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (props) {
                        return [_vm._v(" " + _vm._s(props.row.name) + " ")]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "人数", prop: "customerCount" },
                }),
                _c("el-table-column", {
                  attrs: { label: "更新时间", prop: "updatedDate" },
                }),
                _c("el-table-column", {
                  attrs: { label: "创建人", prop: "createdLabel" },
                }),
                _c("el-table-column", {
                  attrs: { label: "更新方式", prop: "updateWayLabel" },
                }),
                _c("el-table-column", {
                  attrs: { label: "状态", prop: "statusLabel" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          _c(
                            "p",
                            {
                              class:
                                props.row.status == 1
                                  ? "green"
                                  : "" || props.row.status == 2
                                  ? "red"
                                  : "" || props.row.status == 3
                                  ? "gray"
                                  : "",
                            },
                            [_vm._v(" " + _vm._s(props.row.statusLabel) + " ")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "创建时间", prop: "createdDate" },
                }),
                _c("el-table-column", {
                  attrs: { label: "操作", fixed: "right", "min-width": "80px" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          _c(
                            "div",
                            { staticClass: "operateBtn" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.examine(props.row)
                                    },
                                  },
                                },
                                [_vm._v("查看")]
                              ),
                              props.row.status == 1
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.suspension(props.row)
                                        },
                                      },
                                    },
                                    [_vm._v("暂停")]
                                  )
                                : _vm._e(),
                              props.row.status == 2
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.suspension(props.row)
                                        },
                                      },
                                    },
                                    [_vm._v("启用")]
                                  )
                                : _vm._e(),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handlerDownload(props.row)
                                    },
                                  },
                                },
                                [_vm._v("下载")]
                              ),
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-dropdown",
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "el-dropdown-link" },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-more",
                                            staticStyle: {
                                              "font-size": "12px",
                                            },
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "el-dropdown-menu",
                                        {
                                          attrs: { slot: "dropdown" },
                                          slot: "dropdown",
                                        },
                                        [
                                          _c(
                                            "el-dropdown-item",
                                            {
                                              nativeOn: {
                                                click: function ($event) {
                                                  return _vm.changeHistory(
                                                    props.row
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: { type: "text" },
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      return _vm.changeHistory(
                                                        props.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("变更历史")]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-dropdown-item",
                                            {
                                              nativeOn: {
                                                click: function ($event) {
                                                  return _vm.deleteFlock(
                                                    props.row
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "el-button",
                                                { attrs: { type: "text" } },
                                                [_vm._v("删除")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "page" },
          [
            _c("el-pagination", {
              attrs: {
                background: "",
                "current-page": _vm.page.pageNo,
                "page-sizes": [3, 5, 10, 20, 50],
                "page-size": _vm.page.pageSize,
                layout: "total, sizes, prev, pager, next, jumper",
                total: _vm.page.totalNum,
                "prev-text": "上一页",
                "next-text": "下一页",
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          staticClass: "deletegroup",
          attrs: {
            visible: _vm.dialog.visible,
            width: "540px",
            "before-close": _vm.handledeleteClose,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "header-title",
              staticStyle: { display: "flex", "align-items": "center" },
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c(
                "span",
                {
                  class:
                    _vm.dialog.type == "delete"
                      ? "el-iconStyle"
                      : "el-iconStyleTwo",
                },
                [_c("i", { staticClass: "el-icon-warning" })]
              ),
              _c(
                "span",
                {
                  staticStyle: { "padding-left": "12px", "font-size": "22px" },
                },
                [_vm._v(_vm._s(_vm.dialog.title))]
              ),
            ]
          ),
          _vm.dialog.type != "delete"
            ? _c(
                "span",
                { staticStyle: { "font-size": "16px", color: "#333333" } },
                [
                  _vm._v(
                    "是否" + _vm._s(_vm.labelState + _vm.labelName) + "标签？"
                  ),
                ]
              )
            : _vm._e(),
          _vm.dialog.type == "delete"
            ? _c(
                "span",
                { staticStyle: { "font-size": "16px", color: "#333333" } },
                [
                  _vm._v(
                    "是否删除" +
                      _vm._s(_vm.deleteLabelName) +
                      "分群?删除后将影响所有关联该分群的计算功能"
                  ),
                ]
              )
            : _vm._e(),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: {
                    width: "120px",
                    height: "36px",
                    border: "1px solid #d9d9d9",
                    opacity: "1",
                    "line-height": "2px",
                    "border-radius": "4px",
                  },
                  on: {
                    click: function ($event) {
                      _vm.dialog.visible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  staticStyle: {
                    width: "120px",
                    height: "36px",
                    "line-height": "2px",
                    opacity: "1",
                    "border-radius": "4px",
                  },
                  attrs: { type: "primary" },
                  on: { click: _vm.deleteGroup },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [_c("h3", [_vm._v("客户分群")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }